<template>
  <div>
    <van-nav-bar title="个人信息" 
      left-arrow
      @click-left="$router.push({ name: 'ChannelMembers', params: { account: account } })">
    </van-nav-bar>
    <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24" />
        </div>
      </div>
    </van-overlay>
    <van-cell-group>
        <van-cell>
            <template #title>
            <span class="custom-title">头像:</span>
            <span style="float: right;">
             <img :src="avatar" class="imageStyle" />
            </span>
          </template>
        </van-cell>  
        <van-cell>
            <template #title>
            <span class="custom-title">账号:</span>
            <span style="float: right;">{{accountNo}}</span>
          </template>
        </van-cell>
        <van-cell>
            <template #title>
            <span class="custom-title">名称:</span>
            <span style="float: right;">{{user_name}}</span>
          </template>
        </van-cell>  
        <!-- <van-cell>
            <template #title>
            <span class="custom-title">性别:</span>
            <span style="float: right;"></span>
          </template>
        </van-cell>  -->
        <van-cell>
            <template #title>
            <span class="custom-title">电话:</span>
            <span style="float: right;">{{phone}}</span>
          </template>
        </van-cell>
        <!-- <van-cell>
            <template #title>
            <span class="custom-title">邮箱:</span>
            <span style="float: right;">test data</span>
          </template>
        </van-cell>  -->
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "ChannelMemberDetails",
  data() {
    return {
      checked:true,  
      groupName: "",  
      account:"", 
      userAccount:"",
      accountNo:"",
      avatar:"",
      organization:"",
      phone:"",
      user_name:"",
      loadingMask: false,

    };
  },
  computed: {},
  methods: {
    getChannelMemberDetails(){
        let that = this;
        that.loadingMask = true;
        // let toast = that.$toast.loading({
        //  forbidClick: true,
        // });
        let userId = that.userAccount;
        that
        .$wonderChat({
          url: `${localStorage.getItem('chat_api')}/api/user/userdetails/${userId}`,
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          let resData = res.data;
          that.loadingMask = false;
          //toast.clear();
          if(resData.code == 200){
            that.accountNo = resData.data.account;
            that.avatar = resData.data.avatar;
            that.organization = resData.data.organization;
            that.phone = resData.data.phone;
            that.user_name = resData.data.user_name;
          }else{
            that.$toast.fail(resData.msg);
          }
        });
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
  },
  mounted: function (){
      this.isLogin();
      this.account = this.$route.params.chennelId;
      this.groupName = this.$route.params.groupName;
      this.userAccount = this.$route.params.userId;
      this.getChannelMemberDetails();
  }
  };
</script>

<style scoped>

.imageStyle {
  width: 40px;
  border-radius: 25px;
}

</style>


// WEBPACK FOOTER //
// src/components/ChannelMemberDetails.vue